import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-message\"><path d=\"M512 1023.99936a135.935915 135.935915 0 0 0 136.255915-136.959914H375.680085C375.680085 963.007398 436.672047 1023.99936 512 1023.99936zM601.535944 105.791934c125.887921 44.095972 229.055857 178.431888 229.055857 337.407789v125.247922s0 180.415887 44.095972 182.399886h1.343999c25.343984 0 45.439972 20.095987 45.439972 45.375971 0 25.343984-20.095987 45.439972-45.439972 45.439972H147.968228a45.439972 45.439972 0 1 1 1.279999-90.815943c44.095972-1.343999 44.095972-182.399886 44.095972-182.399886V443.199723c0-158.975901 103.103936-293.951816 229.055857-337.407789-1.279999-4.543997-1.279999-9.791994-1.279999-14.975991C421.120057 40.895974 462.016031 0 512 0s90.879943 40.895974 90.879943 90.815943c0 5.183997 0 10.431993-1.343999 14.975991z m0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message.svg
// module id = G2zY
// module chunks = 12